/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResultRange
 */
export interface ResultRange {
    /**
     * index (exclusive) of the last result included
     * @type {number}
     * @memberof ResultRange
     */
    resultEnd: number;
    /**
     * index (inclusive) of the first included result across the total result set
     * @type {number}
     * @memberof ResultRange
     */
    resultStart: number;
}

/**
 * Check if a given object implements the ResultRange interface.
 */
export function instanceOfResultRange(value: object): value is ResultRange {
    if (!('resultEnd' in value) || value['resultEnd'] === undefined) return false;
    if (!('resultStart' in value) || value['resultStart'] === undefined) return false;
    return true;
}

export function ResultRangeFromJSON(json: any): ResultRange {
    return ResultRangeFromJSONTyped(json, false);
}

export function ResultRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultRange {
    if (json == null) {
        return json;
    }
    return {
        
        'resultEnd': json['resultEnd'],
        'resultStart': json['resultStart'],
    };
}

export function ResultRangeToJSON(value?: ResultRange | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'resultEnd': value['resultEnd'],
        'resultStart': value['resultStart'],
    };
}

